import type { AppData } from '../../types/app_data';

import type { AnalyticsUser } from './types';

/**
 * Identify user to Tiktok Pixel.
 *
 * @param user
 */
export const setUserForTikTokPixel = async (user: AnalyticsUser): Promise<void> => {
  const phoneNumber = user.phone?.startsWith?.('+1') ? user.phone : `+1${user.phone}`;
  if (window.ttq) {
    window.ttq.identify({
      external_id: user.id,
      phone_number: user.phone ? phoneNumber : undefined,
    });
  }
};

/**
 * Track signup conversion.
 */
export const trackSignedUpForTikTok = (appData?: AppData): void => {
  if (window.ttq) {
    const eventOptions = appData?.enableLDU ? { limited_data_use: true } : undefined;
    window.ttq.track('Registration', eventOptions);
  }
};

/**
 * Track onboarded conversion.
 */
export const trackOnboardedForTikTok = (appData?: AppData): void => {
  if (window.ttq) {
    const eventOptions = appData?.enableLDU ? { limited_data_use: true } : undefined;
    window.ttq.track('ViewContent', eventOptions);
  }
};
